import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export function changePasswordRequestAction() {
	return { type: CHANGE_PASSWORD_REQUEST };
}

export function changePasswordSuccessAction(data) {
	return { type: CHANGE_PASSWORD_SUCCESS, data };
}

export function changePasswordErrorAction(error) {
	return { type: CHANGE_PASSWORD_ERROR, error };
}

export function fetchChangePasswordPageData(body) {
	return dispatch => {
		dispatch(changePasswordRequestAction());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/4/user/password/update',
				acceptErrors: true
			}),
			body
		).then(
			data => dispatch(changePasswordSuccessAction(data['RESPONSE'])),
			err => {
				return Promise.reject(dispatch(changePasswordErrorAction(err['RESPONSE'])));
			}
		);
	};
}
